import React from "react";
import PropTypes from "prop-types";

const WRAPPER_STYLES = {
  fullscreen: {
    position: 'fixed',
    inset: 0,
    zIndex: 999999,
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  section: {
    width: '100%',
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  table: {
    width: '100%',
    minHeight: '80vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modal: {
    width: '100%',
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inline: {
    display: 'inline-flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    padding: '10px 16px',
    backgroundColor: '#fff',
    borderRadius: '24px',

  },
};

const SPINNER_SCALE = {
  fullscreen: 1,
  section: 0.8,
  table: 0.8,
  modal: 0.5,
  inline: 0.35,
};

export default function LoadingState({ type = 'section', message, style: styleProp }) {
  const wrapperStyle = { ...WRAPPER_STYLES[type], ...styleProp };
  const scale = SPINNER_SCALE[type] ?? 0.7;
  const isInline = type === 'inline';

  return (
    <div style={wrapperStyle}>
      <div style={{
        transform: `scale(${scale})`,
        transformOrigin: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div className="whirly-loader" />
      </div>
      {message && (
        <p style={{
          margin: isInline ? 0 : '20px 0 0 0',
          marginBottom: isInline ? 0 : 0,
          fontSize: isInline ? '14px' : '28px',
          fontWeight: isInline ? 500 : '800',
          color: 'var(--primary)',
          textAlign: isInline ? 'left' : 'center',
          letterSpacing: isInline ? 0 : '0.3px',
          whiteSpace: isInline ? 'nowrap' : 'normal',
        }}>
          {message}
        </p>
      )}

    </div>
  );
}

LoadingState.propTypes = {
  type: PropTypes.oneOf(['fullscreen', 'section', 'table', 'modal', 'inline']),
  message: PropTypes.string,
  style: PropTypes.object,
};
